import { get } from '../base';

import { InvitationStatusResponse } from './types-get-invitation-status';

export function getInvitationStatus(invitationId: string): Promise<InvitationStatusResponse> {
  return get(`v5/invitations/${invitationId}/status`).json();
}
